var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dropdown",
        _vm._b(
          {
            staticClass: "user-action-button",
            on: { command: _vm.handleCommand },
          },
          "el-dropdown",
          _vm.$attrs,
          false
        ),
        [
          _c(
            "span",
            [
              _vm._t("default", function () {
                return [
                  _vm.user && _vm.showInfo
                    ? _c("user-display", {
                        attrs: { user: _vm.user },
                        on: { openUserDetail: _vm.openUserDetail },
                      })
                    : _c(
                        "el-button",
                        {
                          staticStyle: {
                            color: "#ccc",
                            "font-size": "1rem",
                            width: "100%",
                            "border-radius": "8px",
                          },
                        },
                        [_vm._v("بدون کاربر")]
                      ),
                ]
              }),
            ],
            2
          ),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            [
              _c(
                "el-dropdown-item",
                { attrs: { command: "showDeviceInPanel" } },
                [
                  _c("i", { staticClass: "el-icon-link" }),
                  _vm._v("\n        مشاهده این دستگاه\n      "),
                ]
              ),
              _vm.canLoginAs
                ? _c(
                    "el-dropdown-item",
                    {
                      staticClass: "text-success",
                      attrs: { command: "loginAs" },
                    },
                    [
                      _c("i", { staticClass: "el-icon-s-custom " }),
                      _vm._v("\n        ورود به عنوان این کاربر\n      "),
                    ]
                  )
                : _vm._e(),
              _vm.showResetDevice
                ? _c(
                    "el-dropdown-item",
                    {
                      staticStyle: { color: "#ef394e" },
                      attrs: { command: "resetDevice" },
                    },
                    [
                      _c("i", { staticClass: "el-icon-refresh" }),
                      _vm._v("\n        ریست‌کردن این دستگاه\n      "),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }